/* --------------------------------------------------------------------------------
    *   hide_email.METHOD({PARAMS});

        Schuetzt die E-Mail Adresse von Robots
    
    Diese Params koennen ueberschrieben werden, falls sie vom Default abweichen.
    PARAMS: 
        {   
            debug: false,
            elm: '', // '.#class_field# span.mail'
            em1: '', // '#email1#'
            em2: '', // '#email2#'
            atxt:''
        }

    METHODS:
    * write_link
        - setzt die E-Mail-Adresse mit span zusammmen
        Bsp.:
            hide_email.write_link({params});
        Return: ---
----------------------------------------------------------------------------------- */
var hide_email = (function() {
    "use strict"; // Preventing you from using undeclared variables. IE 9 will not throw an error even if it does not understand it.

    // --------------------------------------------------------------------------------
    //  *   Private Vars
    //  -------------------------------------------------------------------------------
    var params = {
        debug: false,
        elm: '', // '.#class_field# span.mail'
        em1: '', // '#email1#'
        em2: '', // '#email2#'
        atxt:''
    };

    var settings = $.extend({} ,params),
        debug = settings.debug,
        clickEventType = (mobileCheck.init()) ? 'touchend' : 'click';
    
    // --------------------------------------------------------------------------------
    //  *   Public Methods
    //  -------------------------------------------------------------------------------
    var write_link = function(params) {
        set_params(params);

        if (settings.em1.length > 0 && settings.em2.length > 0) {
            if( settings.atxt.length == 0) {
                settings.atxt = '<span class="txt">'+settings.em1+'<span class="dspatsign"></span>'+settings.em2+'</span>'; 
            }
            $(settings.elm).append('<div class="execute_hide_email" data-em1="'+settings.em1+'" data-em2="'+settings.em2+'">'+settings.atxt+'</div>'); 
            $(".execute_hide_email").on(clickEventType, execute_link);
        }
        else {
            $(settings.elm).append(' -- No email address supplied -- ');    
        }
    };

    var execute_link = function() {
        window.location.href = "mailto:"+settings.em1+'@'+settings.em2;
        return false;
    }

    // --------------------------------------------------------------------------------
    //  *   Private Methods
    //  -------------------------------------------------------------------------------
    var set_params = function() {
        $.each(Array.prototype.slice.call(arguments), function(i, val) {
            if (typeof val == 'object' ) {
                settings = $.extend(params, val);
            }
            else {
                var key = 'param_'+i,
                    obj = {};
                    obj[val] = val;
                    obj[key] = val;
                
                settings = $.extend(params, obj);
            }
        });
        debug = settings.debug;
    };

    // --------------------------------------------------------------------------------
    //  *   Public Methods API (Aufruf)
    //  -------------------------------------------------------------------------------
    return {
        write_link: write_link,
    };
})( jQuery );// ---------- * end: hide_email * --------------------